// extracted by mini-css-extract-plugin
export var chip = "_ck-0";
export var filterDropdown = "_ck-5";
export var filterItem = "_ck-6";
export var icon = "_ck-1";
export var removeButton = "_ck-3";
export var removeIcon = "_ck-4";
export var separator = "_ck-2";